'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDayPicker = require('react-day-picker');

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

var _calendarUtil = require('../../calendarUtil');

var _calendarUtil2 = _interopRequireDefault(_calendarUtil);

var _calendarLocales = require('../../calendarLocales');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formStep = require('../../container/steps/formStep');

var _formStep2 = _interopRequireDefault(_formStep);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SuggestionSelector = function (_React$Component) {
  _inherits(SuggestionSelector, _React$Component);

  function SuggestionSelector(props) {
    _classCallCheck(this, SuggestionSelector);

    var _this = _possibleConstructorReturn(this, (SuggestionSelector.__proto__ || Object.getPrototypeOf(SuggestionSelector)).call(this, props));

    _this.store = BookingFormStore;
    return _this;
  }

  _createClass(SuggestionSelector, [{
    key: 'isOptionSelected',
    value: function isOptionSelected() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var content = [];
      var dates = this.state.suggestedTimes;

      var _loop = function _loop(i) {
        var date = new Date(dates[i] * 1000);
        content.push(_react2.default.createElement('div', {
          onClick: function onClick(e) {
            return _this2.setState({
              currentSelectedOption: dates[i]
            });
          },
          key: "ts_" + i,
          className: 'slrhp_termSuggestionLine',
          style: {
            cursor: "pointer",
            display: "inline-flex",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderTopStyle: "solid",
            borderTopWidth: "1px",
            width: "100%"
          }
        }, _react2.default.createElement('div', {
          className: 'slrhp_termSuggestionLine_label',
          style: {
            width: "20%",
            marginLeft: "12px"
          }
        }, i + 1 + ". Vorschlag:", '  '), _react2.default.createElement('div', {
          className: 'slrhp_termSuggestionLine_date',
          style: {
            width: "60%",
            textAlign: "center"
          }
        }, date.toLocaleDateString() + " " + date.toLocaleTimeString().substr(0, 5) + " Uhr"), _react2.default.createElement('div', {
          style: {
            width: "20%"
          }
        }, _react2.default.createElement('input', {
          className: 'sls-radios__input',
          type: 'checkbox',
          checked: _this2.isOptionSelected(dates[i])
        }), _react2.default.createElement('div', {
          className: 'sls-radios__img',
          style: {
            marginRight: "12px"
          }
        }))));
      };

      for (var i = 0; i < dates.length; i++) {
        _loop(i);
      }

      return _react2.default.createElement('div', null, content);
    }
  }]);

  return SuggestionSelector;
}(_react2.default.Component);

var locale = "de";

var TimeSlotSelector = function (_React$Component2) {
  _inherits(TimeSlotSelector, _React$Component2);

  function TimeSlotSelector(props) {
    _classCallCheck(this, TimeSlotSelector);

    var _this3 = _possibleConstructorReturn(this, (TimeSlotSelector.__proto__ || Object.getPrototypeOf(TimeSlotSelector)).call(this, props));

    _this3.state = {
      valid: props.day && props.hour && props.minute,
      showSuggestions: false,
      currentSelectedOption: null,
      day: props.day,
      hour: props.hour,
      minute: props.minute,
      errorMessages: []
    };
    _this3.handleInputChange = _this3.handleInputChange.bind(_this3);
    return _this3;
  }

  _createClass(TimeSlotSelector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loadBookingTimes();

      _reactGa2.default.event({
        category: "OTB",
        action: "Step",
        label: "Timeslot"
      });

      this.validate();
    }
  }, {
    key: 'getFormData',
    value: function getFormData() {
      var _state = this.state,
          day = _state.day,
          hour = _state.hour,
          minute = _state.minute;
      return {
        stepId: "timeslot",
        formData: {
          day: day,
          hour: hour,
          minute: minute
        }
      };
    }
  }, {
    key: 'validate',
    value: function validate() {
      var errorMessages = [];
      var valid = true;

      if (!this.state.day) {
        errorMessages.push("Bitte wählen Sie einen Tag aus.");
        valid = false;
      }

      if (!this.state.hour || !this.state.minute) {
        errorMessages.push("Bitte wählen Sie eine Uhrzeit aus.");
        valid = false;
      }

      this.setState({
        valid: valid,
        errorMessages: errorMessages
      });

      if (valid) {
        this.props.enableSubmit();
      } else {
        this.props.disableSubmit();
      }
    }
  }, {
    key: 'isDayDisabled',
    value: function isDayDisabled(day) {
      day.setHours(0);
      return this.props.availableTimes[day.getTime() / 1000] == null || this.props.availableTimes[day.getTime() / 1000].filter(function (time) {
        return time.IsAvailable;
      }).length === 0;
    }
  }, {
    key: 'clickDay',
    value: function clickDay(day, _ref) {
      var disabled = _ref.disabled,
          selected = _ref.selected;
      if (disabled) return;

      if (!selected) {
        var hours = this.getHoursForDay(day);

        var _firstEnabledTime = this.firstEnabledTime(hours),
            hour = _firstEnabledTime.hour,
            minute = _firstEnabledTime.minute;

        this.setState({
          day: day,
          hour: hour,
          minute: minute
        }, this.validate);
      }
    }
  }, {
    key: 'getHoursForDay',
    value: function getHoursForDay(day) {
      var result = {};
      var availableTimes = [];
      var dayTime = day.getTime() / 1000;

      if (this.props.availableTimes.hasOwnProperty(dayTime)) {
        availableTimes = this.props.availableTimes[dayTime];
      }

      var processedTimes = [];

      if (availableTimes.length > 0) {
        processedTimes = _calendarUtil2.default.createDropDownData(availableTimes);
      }

      var hours = Object.keys(processedTimes);

      for (var i = 0; i < hours.length; i++) {
        var hour = hours[i];
        var disabledHour = !processedTimes[hours[i]].hasAvailableTimes;
        var hourLabel = hour < 10 ? '0' + hour : hour;
        var min = {};
        var minutes = Object.keys(processedTimes[hours[i]].minutes);

        for (var j = 0; j < minutes.length; j++) {
          var minute = minutes[j];
          var disabledMinute = !processedTimes[hours[i]].minutes[minute];
          var minuteLabel = minute < 10 ? '0' + minute : minute;
          min[minute] = {
            label: minuteLabel,
            disabled: disabledMinute
          };
        }

        result[hour] = {
          label: hourLabel,
          disabled: disabledHour,
          minutes: min
        };
      }

      return result;
    }
  }, {
    key: 'firstEnabledTime',
    value: function firstEnabledTime(hours) {
      var hourKeys = Object.keys(hours);

      for (var i = 0; i < hourKeys.length; i++) {
        var hour = hours[hourKeys[i]];
        var minuteKeys = Object.keys(hour.minutes);

        for (var j = 0; j < minuteKeys.length; j++) {
          var minute = hour.minutes[minuteKeys[j]];

          if (!hour.disabled && !minute.disabled) {
            return {
              hour: hourKeys[i],
              minute: minuteKeys[j]
            };
          }
        }
      }
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.type === 'checkbox' ? target.checked : target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value), this.validate);
    }
  }, {
    key: 'renderSuggestions',
    value: function renderSuggestions() {
      var _this4 = this;

      return _react2.default.createElement('div', null, _react2.default.createElement(SuggestionSelector, {
        suggestedTimes: this.state.suggestedTimes
      }), _react2.default.createElement('a', {
        href: 'javascript:void(0);',
        className: 'slrhp_a',
        onClick: function onClick(e) {
          return _this4.setState({
            showSuggestions: false
          });
        }
      }, _react2.default.createElement('span', {
        className: 'slrhp_txt'
      }, 'Anderen Termin w\xE4hlen')));
    }
  }, {
    key: 'renderCombinedSelect',
    value: function renderCombinedSelect() {
      var _this5 = this;

      var options = [];
      var hours = {};

      if (this.state.day) {
        hours = this.getHoursForDay(this.state.day);
      }

      var onChange = function onChange(event) {
        var value = event.target.value;
        var hour = value.substr(0, 2);
        var minute = value.substr(2, 2);

        _this5.setState({
          hour: hour,
          minute: minute
        }, _this5.validate);
      };

      var keys = Object.keys(hours);

      for (var i = 0; i < keys.length; i++) {
        var hour = hours[keys[i]];
        var minuteKeys = Object.keys(hour.minutes);

        for (var j = 0; j < minuteKeys.length; j++) {
          var minute = hour.minutes[minuteKeys[j]];

          if (!hour.disabled && !minute.disabled) {
            var option = _react2.default.createElement('option', {
              key: "hm" + keys[i] + minuteKeys[j],
              value: keys[i] + minuteKeys[j]
            }, hour.label + ":" + minute.label);

            options.push(option);
          }
        }
      }

      return _react2.default.createElement('select', {
        name: 'hour',
        disabled: this.state.day === null,
        className: 'semi',
        value: this.state.hour + this.state.minute || "",
        onChange: onChange
      }, options);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var currentDate = new Date();
      var maxDate = new Date();
      maxDate.setMonth(currentDate.getMonth() + 4);

      if (this.state.showSuggestions && this.state.suggestedTimes.length > 0) {
        return this.renderSuggestions();
      } else {
        return _react2.default.createElement('div', null, _react2.default.createElement('div', {
          className: 'sub'
        }, 'Auswahl Termin', _react2.default.createElement('div', null, _react2.default.createElement('div', null))), _react2.default.createElement('div', {
          className: 'group'
        }, _react2.default.createElement(_reactDayPicker2.default, {
          locale: locale,
          months: _calendarLocales.MONTHS[locale],
          weekdaysLong: _calendarLocales.WEEKDAYS_LONG[locale],
          weekdaysShort: _calendarLocales.WEEKDAYS_SHORT[locale],
          firstDayOfWeek: _calendarLocales.FIRST_DAY_OF_WEEK[locale],
          labels: _calendarLocales.LABELS[locale],
          fixedWeeks: true,
          selectedDays: this.state.day,
          disabledDays: [{
            before: currentDate,
            after: maxDate
          }, function (day) {
            return _this6.isDayDisabled(day);
          }],
          onDayClick: this.clickDay.bind(this)
        }), _react2.default.createElement('div', {
          className: 'line'
        }, _react2.default.createElement('div', {
          className: 'blank'
        }, _react2.default.createElement('div', {
          className: 'label'
        }, 'Uhrzeit:'), _react2.default.createElement('div', {
          className: 'small'
        }, this.renderCombinedSelect()), _react2.default.createElement('div', {
          className: 'right'
        })))));
      }
    }
  }]);

  return TimeSlotSelector;
}(_react2.default.Component);

TimeSlotSelector.propTypes = {
  availableTimes: _propTypes2.default.object.isRequired,
  loadBookingTimes: _propTypes2.default.func.isRequired,
  isLoadingBookingTimes: _propTypes2.default.bool.isRequired,
  day: _propTypes2.default.object,
  hour: _propTypes2.default.string,
  minute: _propTypes2.default.string
};
exports.default = (0, _formStep2.default)(TimeSlotSelector);